import { Component, Vue, Prop } from "vue-property-decorator";
import { WorkStationAlarmVO } from '@/service-proxies/app-v2/mdc.service-proxies';

@Component({
})
export default class AlarmBarChart extends Vue {
  @Prop({ default: () => ([]) }) readonly columns: Array<any>;
  @Prop({ default: () => ({}) }) readonly dataValue: WorkStationAlarmVO;
  @Prop({ default: null }) index: number
  color = ['#FA554C','#E1A400','#FDBB08','#E2CB00','#2A9F0C','#7ED321','#ABDE2F','#E0E0E0','#B4B4B4','#37a002','#9d96f5','#8378EA','#96BFFF']
  mounted() {
    this.init()
  }

  mathDataLength(){
    return (90 / this.dataValue.alarmInfoList.length).toFixed(2)
  }

  init() {
    const seriesData = []
    const legendData = []
    this.dataValue.alarmInfoList.forEach(res =>{
      legendData.push(res.code)
      seriesData.push(res.count)
    })
    // 基于准备好的dom，初始化echarts实例
    var myChart = (this as any).$echarts.init(
      this.$refs.myChart as any
    );
    // 指定图表的配置项和数据
    var option = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        show: (this.dataValue.alarmInfoList.length > 1),
        data: legendData,
        selectedMode: false
      },
      grid: {
        left: '3%',
        right: '3%',
        bottom: '4%',
        top: '20',
        containLabel: true
      },
      color: this.color,
      xAxis: {
        type: 'category',
        axisLabel: {
          show: true,
          interval: 0,
          formatter: (val) => {
            var strs = val.split(''); //字符串数组
            var str = ''
            for(var i = 0, s; s = strs[i++];) { //遍历字符串数组
            str += s;
            if(!(i % 6)) str += '\n'; //按需要求余
            }
            return str
          },
        },
        axisLine: {onZero: true},
        data: legendData
      },
      yAxis: [
        {
          type: 'value',
          boundaryGap: true,
          axisLine: {
              show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
                type: 'dashed'
            }
          },
        }
      ],
      series: [{
        type: 'bar',
        label: {
          show: true,
          position: 'top'
        },
        data: seriesData
      }]
    };
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
  }
  render() {
    return (
      <div ref="myChart" style={{width: 75 * (this.dataValue.alarmInfoList.length > 6 ? this.dataValue.alarmInfoList.length : 6) + 'px', height: '300px'}}></div>
    )
  }
}